import React, {useState} from 'react';
import DatePicker from 'react-datepicker';
import {Button, Spinner} from 'reactstrap';

interface ICustomRangeSelectorProps {
  updateDateRange: (startDate: Date, endDate: Date) => void;
  disableAutoHide?: () => void;

  startDateRange: Date;
  endDateRange: Date;
  disableDatePicker: boolean;
  disableSubmitButton?: boolean;
  isDataLoading?: boolean;
}

export const CustomRangeSelector = (props: ICustomRangeSelectorProps) => {
  const {
    startDateRange,
    endDateRange,
    disableDatePicker,
    updateDateRange,
    isDataLoading,
    disableAutoHide,
    disableSubmitButton,
  } = props;
  const [selectedStartDate, setSelectedStartDate] = useState(startDateRange);
  const [selectedEndDate, setSelectedEndDate] = useState(endDateRange);

  const handleStartDateSelection = (date) => {
    setSelectedStartDate(date);
    if (disableSubmitButton) {
      updateDateRange(date, selectedEndDate);
    } else {
      disableAutoHide()
    }
  };

  const handleEndDateSelection = (date) => {
    setSelectedEndDate(date);
    if (disableSubmitButton) {
      updateDateRange(selectedStartDate, date);
    } else {
      disableAutoHide()
    }
  };

  return (
    <div className="datepicker-container">
      <span>From: </span>
      <DatePicker
        selected={selectedStartDate}
        onChange={(date) => {
          handleStartDateSelection(date);
        }}
        selectsStart
        startDate={startDateRange}
        endDate={endDateRange}
        className={
          disableDatePicker ? 'margin-bottom text-muted' : 'margin-bottom'
        }
      />
      <span>To: </span>
      <DatePicker
        selected={selectedEndDate}
        onChange={(date) => {
          handleEndDateSelection(date);
        }}
        selectsEnd
        startDate={startDateRange}
        endDate={endDateRange}
        minDate={selectedStartDate}
        className={
          disableDatePicker ? 'margin-bottom text-muted' : 'margin-bottom'
        }
      />
      {!disableSubmitButton &&
        <div className="mt-3">
          <Button
            className="btn-block p-1"
            color="primary"
            onClick={() => {
              updateDateRange(selectedStartDate, selectedEndDate);
            }}
          >
            {isDataLoading ? (
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            ) : (
              'Submit'
            )}
          </Button>
        </div>
      }
    </div>
  );
};
